import React from "react";
import { TableCellRenderer } from "react-table";
import * as moment from "moment-timezone";
import styled from "styled-components";

import { CustomTableColumn } from "src/library/components/Tables/Table";
import { Text } from "src/library/components/Text/Text";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";

export const openDaysTableColumns = (ActionButton: TableCellRenderer): CustomTableColumn[] => [
  globalTableColumns.id(),
  globalTableColumns.standardText({
    Header: "Reason",
    accessor: "reason",
    width: 250,
    textTransform: "none"
  }),
  globalTableColumns.standardText({
    Header: "Dates",
    id: "startDate",
    width: 400,
    accessor: "startDate",
    Cell: ({ original }) => {
      if (original.endDate !== original.startDate) {
        return (
          <ShutdownCell>
            <Text>
              {`${moment.utc(original.startDate).format("DD/MM/YYYY")} - ${moment.utc(original.endDate).format("DD/MM/YYYY")}`}
            </Text>
          </ShutdownCell>
        );
      } else {
        return (
          <ShutdownCell>
            <Text>
              {`${moment.utc(original.startDate).format("DD/MM/YYYY")}`}
            </Text>
          </ShutdownCell>
        );
      }
    }
  }),
  globalTableColumns.actions({ cell: ActionButton })
];

const ShutdownCell = styled.div`
  padding: 20px 0;
  white-space: pre-wrap;
`;
